import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Delete,
  Send
} from '@material-ui/icons';
import MaterialTable from 'material-table';
import '../../assets/stylesheets/SkuCarryover.css';
import 'react-datasheet/lib/react-datasheet.css';
import i18n from '../../i18n';
import { tableIcons } from '../shared/icons';

class SkuTable extends Component {
  render() {
    const {
      skus,
      onClickDelete,
      onClickMerge,
    } = this.props;

    return (

      <MaterialTable
        title={i18n.t('carryover:previewTableTitle')}
        columns={[
          {
            field: 'status',
          },
          {
            title: i18n.t('carryover:oldSku'),
            field: 'oldSku',
            sorting: false,
          },
          {
            title: i18n.t('carryover:newSku'),
            field: 'newSku',
            sorting: false
          },

        ]}
        data={skus}
        icons={tableIcons}
        options={{
          selection: true,
          rowStyle: rowData => ({ backgroundColor: (rowData.status === 'failed') ? '#ff6781' : '' }),
          pageSize: 50,
          pageSizeOptions: [50, 75, 100]
        }}
        actions={[
          {
            tooltip: i18n.t('carryover:mergeTooltip'),
            icon: Send,
            iconProps: { style: { fontSize: '12px', width: 'auto', overflow: 'visible', font: 'bold', fontWeight: 'bold', color: 'blue' } },
            onClick: onClickMerge,
          },
          {
            tooltip: i18n.t('carryover:deleteTooltip'),
            icon: Delete,
            iconProps: { style: { fontSize: '12px', width: 'auto', overflow: 'visible', fontWeight: 'bold', color: '#ff6781' } },
            onClick: onClickDelete,
          }
        ]}
      />
    );
  }
}

SkuTable.propTypes = {
  skus: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClickMerge: PropTypes.func.isRequired,
  onClickDelete: PropTypes.func.isRequired,
};

export default SkuTable;
